var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStage9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50.104,
    height: 50.104,
    viewBox: "0 0 50.104 50.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1733",
    "data-name": "Rectangle 1733",
    width: 36.217,
    height: 34.58,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32119",
    "data-name": "Group 32119",
    transform: "translate(-29.391 -26.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stage_9:_Winback",
    "data-name": "Stage 9: Winback",
    transform: "translate(29.391 26.334)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_688",
    "data-name": "Ellipse 688",
    cx: 25.052,
    cy: 25.052,
    rx: 25.052,
    ry: 25.052,
    fill: "#ee3d4b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32067",
    "data-name": "Group 32067",
    transform: "translate(6.84 7.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32066",
    "data-name": "Group 32066",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13536",
    "data-name": "Path 13536",
    d: "M25.03,6.245a2.9,2.9,0,0,1,2.581-2.33,7.419,7.419,0,0,1,2.944,1.291A7.393,7.393,0,0,1,33.5,3.915a2.9,2.9,0,0,1,2.586,2.33c.279,1.027.706,4.659-5.451,8.258a.132.132,0,0,1-.078.021.151.151,0,0,1-.078-.021c-6.155-3.6-5.727-7.233-5.45-8.258m-2.708,9.071a1.776,1.776,0,0,1,1.588-1.429,4.484,4.484,0,0,1,1.807.794,4.551,4.551,0,0,1,1.808-.794,1.78,1.78,0,0,1,1.588,1.429c.176.63.434,2.862-3.352,5.07a.115.115,0,0,1-.048.014.089.089,0,0,1-.048-.014c-3.781-2.209-3.516-4.44-3.352-5.07M7.9.081a6.832,6.832,0,1,1-.007,0l.007,0m-6.8,34.4L.975,23.959a28.245,28.245,0,0,0,5.774,7,2.844,2.844,0,0,0,2.052.693,37.481,37.481,0,0,0,5.832-.926c.49-.12,1.369-.374,1.909-.529l.069,4.379Zm13.385-4.792a37.4,37.4,0,0,1-5.727.914,2.217,2.217,0,0,1-1.588-.529c-.741-.644-5.529-4.94-6.778-9.587-.466-1.732-.7-4.135.307-5.351a3.906,3.906,0,0,1,2.664-1.533l10.141-.056a.806.806,0,0,1,.131,0,5.7,5.7,0,0,1,3.4,1.191,11.342,11.342,0,0,1,3.881,6.245,12.652,12.652,0,0,1-3.858,2.346,18.048,18.048,0,0,1-1.2-3.176l.545,3.414A32.9,32.9,0,0,1,9.8,24.9a58.368,58.368,0,0,1-4.6-4.853l-.284.042a20.431,20.431,0,0,0,4.483,6c2.39-.275,8.9-1.3,12.266-4.515a2.218,2.218,0,0,1,3.063,3.206,22.7,22.7,0,0,1-10.232,4.911m20.6-5.543A28.865,28.865,0,0,1,24.677,29.21a8.1,8.1,0,0,1-4.181.132,3.994,3.994,0,0,1-.577-.252,18.56,18.56,0,0,0,5.811-3.578,2.845,2.845,0,0,0,.842-1.6A20.976,20.976,0,0,0,31.963,21a2.218,2.218,0,0,1,3.123,3.151",
    transform: "translate(0 0)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage9);
export default __webpack_public_path__ + "static/media/stage9.a0cc290364b098a4aa25dd05dd5c2e28.svg";
export { ForwardRef as ReactComponent };